import Breadcrumbs from "../../../components/breadcrumbs";
import EmailTemplateCreateForm from "./ui/email-template-create-form";

export default function EmailTemplateCreatePage(){
     return (
            <main className="max-w-3xl ">
              <Breadcrumbs
                breadcrumbs={[
                  { label: "Email Templates", href: "/admin/email-templates" },
                  {
                    label: "create",
                    href: `/admin/email-templates/Create`,
                    active: true,
                  },
                ]}
              />
              
                <EmailTemplateCreateForm/>
              
            </main>
          );
        }
        